class StickyAddToCard extends HTMLElement {
    constructor() {
        super();
        this.stickyContainer = this.querySelector('.sticky-container');
        this.details = this.stickyContainer?.querySelector('details');
        this.stickyContent = this.stickyContainer?.querySelector('.add-to-cart-sticky__content');
        this.mainBuyButtons = document.querySelector('.hd-product-page .product__info-block--buy_buttons');
        this.footer = document.querySelector('.footer-section');
        this.stickyVariantInput = this.querySelector('form input[name="id"]');
        this.handleScroll = this.handleScroll.bind(this);
        this.handleDetailsClick = this.handleDetailsClick.bind(this);
        this.syncVariant = this.syncVariant.bind(this);
    }

    connectedCallback() {
        this.close();
        this.details?.addEventListener('click', this.handleDetailsClick);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });
        document.addEventListener('change', this.syncVariant);
        this.handleScroll();
    }

    handleDetailsClick(event) {
        const details = event.target.closest('details');
        if (!details) return;
        details.open ? this.close() : this.open();
    }

    open() {
        if (!this.stickyContent) return;
        this.stickyContent.style.height = `${this.stickyContent.scrollHeight}px`;
        this.stickyContent.style.opacity = '1';
    }

    close() {
        if (!this.stickyContent) return;
        this.stickyContent.style.height = '0';
        this.stickyContent.style.opacity = '0';
    }

    syncVariant(event) {
        const source = event.target;
        if (!source.matches('.hd-product-page product-form input[name="id"]')) return;
        if (this.stickyVariantInput) {
            this.stickyVariantInput.value = source.value;
        }
    }

    handleScroll() {
        if (window.innerWidth >= 750 || !this.mainBuyButtons) {
            this.setVisible(false);
            return;
        }

        const buyButtonsRect = this.mainBuyButtons.getBoundingClientRect();
        const footerRect = this.footer?.getBoundingClientRect();
        const passedPurchaseArea = buyButtonsRect.bottom < 0;
        const footerIsClear = !footerRect || footerRect.top > window.innerHeight + this.offsetHeight;
        this.setVisible(passedPurchaseArea && footerIsClear);
    }

    setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        document.body.classList.toggle('hd-sticky-purchase-visible', visible);
    }

    disconnectedCallback() {
        this.details?.removeEventListener('click', this.handleDetailsClick);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        document.removeEventListener('change', this.syncVariant);
        document.body.classList.remove('hd-sticky-purchase-visible');
    }
}

if (!customElements.get('sticky-add-to-card')) {
    customElements.define('sticky-add-to-card', StickyAddToCard);
}
